import React, { useState } from 'react';
import { Modal, Box, Button, Typography, Grid } from '@mui/material';

// Importiamo i componenti dei form che definiremo sotto
import { StudentForm } from './StudentForm';
import { BusinessForm } from './BusinessForm';

const style = {
  width: '100%',
  maxWidth: 640,
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  overflowY: 'auto',
};

const SignupModal = ({ open, onClose, onRegisterSuccess }) => {
  const [userType, setUserType] = useState(null); // 'student' o 'business'

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      keepMounted
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
    >
      <Box sx={style}>
        {!userType ? (
          // --- VISTA INIZIALE DI SCELTA ---
          <>
            <Typography variant="h5" textAlign="center" gutterBottom>Registrati Come</Typography>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" size="large" onClick={() => setUserType('student')} sx={{ p: 3 }}>
                  Studente / Alunno
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" size="large" onClick={() => setUserType('business')} sx={{ p: 3 }}>
                  Azienda Partner
                </Button>
              </Grid>
            </Grid>
          </>
        ) : userType === 'student' ? (
          // --- FORM PER LO STUDENTE ---
          <StudentForm onRegisterSuccess={onRegisterSuccess} />
        ) : (
          // --- FORM PER L'AZIENDA ---
          <BusinessForm onRegisterSuccess={onRegisterSuccess} />
        )}

        {userType && (
            <Button onClick={() => setUserType(null)} sx={{ mt: 2 }}>
                Indietro
            </Button>
        )}
      </Box>
    </Modal>
  );
};

export default SignupModal;